export enum NotificationTopics {
  MANDATORY = 'mandatory',
  MARKETING = 'marketing'
}

export enum NotificationPresentAt {
  DASHBOARD = 'dashboard',
  EVERYWHERE = 'everywhere',
  LANDING = 'landing'
}
